import { authCache } from '@/auth/authCache';

export const getRefreshToken = async (): Promise<string | undefined> => {
  const keys = (await authCache.allKeys?.()) ?? [];
  const auth0CacheKey = keys.find((key) => key.includes('offline_access'));
  if (!auth0CacheKey) {
    return undefined;
  }

  const auth0Cache = await authCache.get(auth0CacheKey);
  //@ts-expect-error - auth0Cache.body.refresh_token is not typed
  return auth0Cache?.body?.refresh_token;
};
